module.exports = __webpack_public_path__ + "img/avatar.c7b5f6a0.png";